import { IDropDownOption } from "../../sections/TextSection"
import { Field } from "./Field"
export class DropDownField extends Field {
  private options: IDropDownOption[]
  type:string = "dropdown"
  constructor(
    name: string,
    value: any,
    options: IDropDownOption[],
    onChange: (newValue: any) => void,
  ) {
    super(name, value, onChange)
    this.options = options
  }

  public render(): HTMLElement {
    const container = this.createContainer();

    // Create a wrapper div for styling
    const wrapper = document.createElement('div');
    wrapper.className = 'select-container'; // Add a wrapper for styling

    const select = document.createElement('select');
    select.id = this.name;
    select.name = this.name;
    select.addEventListener('change', (event) => {
        const target = event.target as HTMLSelectElement;
        this.onChange(target.value);
        this.value = target.value;
    });

    (select as any)['fieldObj'] = this;

    this.options.forEach((option) => {
        const optionEl = document.createElement('option') as HTMLOptionElement;
        optionEl.value = option.value;
        optionEl.textContent = option.label;
        if (option.value === this.value) {
            optionEl.selected = true;
        }
        select.appendChild(optionEl);
    });

    select.value = this.value?.replaceAll("\"", "");

    // Append select inside wrapper
    wrapper.appendChild(select);
    container.appendChild(wrapper);

    return container;
}

}